// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { complimentaryCategoriesStyles } from "@rugby/App/Widgets/ProductDetails/ComplimentaryCategories";
import { color } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

complimentaryCategoriesStyles.wrapper = {
    css: css`
        margin: 30px 0;
        padding: 12px 0;
    `,
};
complimentaryCategoriesStyles.innerWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        padding: 15px 0;
        ${({ gap }: any) => `gap: ${gap}px`};
    `,
};
complimentaryCategoriesStyles.categoryWrapper = {
    css: css`
        ${({ numPerRow, gap }: any) => `flex: 0 0 calc(100%/${numPerRow} - ${gap}px)`};
        max-width: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
};
complimentaryCategoriesStyles.clickableImage = {
    css: css`
        width: 100%;
        height: auto;
        border: 1px solid ${color("common.black")};
        aspect-ratio: 1;
        justify-content: center;
    `,
};
complimentaryCategoriesStyles.linkStyle = {
    css: css`
        margin-top: 10px;
        font-weight: bold;
        text-align: center;
        word-break: break-word;
        white-space: normal;
        overflow-wrap: break-word;
        padding: 0 5px;
        width: 100%;
        display: flex;
        justify-content: center;
    `,
};
